export const NAME = 'dentalCoverage'

export const GET_DENTAL_PLANS = 'clientBenefitsDentalGet'
export const POST_DENTAL_PLANS = 'clientBenefitsDentalPost'
